var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { MenuIcon } from '@heroicons/react/outline';
import { Collapsible, Dialog, styled } from '@showroomjs/ui';
import * as React from 'react';
import { ErrorBound } from './error-fallback';
/**
 * This component is mostly a shameless copy from `docusaurus`.
 *
 * @see https://github.com/facebook/docusaurus/blob/b6d0378704d68f5d6ac821243f7a1ae19d5ccdbe/website/src/components/BrowserWindow/styles.module.css
 */
export const BrowserWindow = (_a) => {
    var { minHeight = 'auto', children, url } = _a, props = __rest(_a, ["minHeight", "children", "url"]);
    const [show, setShow] = React.useState(true);
    const [showDialog, setShowDialog] = React.useState(false);
    return (React.createElement(BrowserWindowWrapper, Object.assign({ style: { minHeight } }, props),
        React.createElement(Dialog, { open: showDialog, onOpenChange: setShowDialog },
            React.createElement(Collapsible.Root, { open: show, onOpenChange: setShow },
                React.createElement(BrowserWindowHeader, null,
                    React.createElement(Buttons, null,
                        React.createElement(Dot, { style: { background: '#f25f58' } }),
                        React.createElement(Collapsible.Button, { asChild: true },
                            React.createElement(Dot, { as: "button", style: { background: '#fbbe3c' }, "aria-label": show ? 'Show' : 'Collapse' })),
                        React.createElement(Dialog.Trigger, { asChild: true },
                            React.createElement(Dot, { as: "button", style: { background: '#58cb42' }, "aria-label": "Open focus view" }))),
                    React.createElement(BrowserWindowAddressBar, null, url),
                    React.createElement("div", null,
                        React.createElement(BrowserMenu, { width: 20, height: 20 }))),
                React.createElement(Collapsible.Content, null,
                    React.createElement(ErrorBound, null, children))),
            React.createElement(Dialog.Content, { fullWidth: true },
                React.createElement(ErrorBound, null, children)))));
};
const BrowserMenu = styled(MenuIcon, {
    color: '$gray-300',
});
const BrowserWindowWrapper = styled('div', {
    border: '3px solid $gray-500',
    borderRadius: '$md',
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px',
});
const BrowserWindowHeader = styled('div', {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '$gray-500',
    padding: '0.5rem 1rem',
});
const Buttons = styled('div', {
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
});
const Dot = styled('span', {
    display: 'inline-block',
    height: 12,
    width: 12,
    marginRight: 6,
    backgroundColor: '#bbb',
    borderRadius: '50%',
});
const BrowserWindowAddressBar = styled('div', {
    flex: '1 0',
    margin: '0 1rem 0 0.5rem',
    borderRadius: '12.5px',
    backgroundColor: '#fff',
    color: '$gray-800',
    padding: '5px 15px',
    font: '400 13px Arial',
    userSelect: 'none',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
});
//# sourceMappingURL=browser-window.js.map